export default __webpack_public_path__ + "static/media/master-class-3.96ed9d4a.jpeg";